export default __webpack_public_path__ + "static/media/homemeds_logo.32d14017.svg";